import PropTypes from "prop-types";
import cn from "classnames";

import { keyify } from "@utils/keyify";
import { tagular } from "@cohesion/tagular";

export function Tabs({ items, handleSelect, activeIndex, poiTitle }) {
  return (
    <nav>
      <ul className="flex gap-4">
        {items.map((item, i) => (
          <li key={keyify(item.label)}>
            <button
              type="button"
              className={cn(
                "border-b-2 pb-2 md:text-lg font-semibold",
                activeIndex === i
                  ? "text-blue border-blue"
                  : "border-transparent"
              )}
              onClick={() => {
                handleSelect(i);
                tagular("click", {
                  actionOutcome: "TOGGLE",
                  outboundUrl: "null",
                  webElement: {
                    elementType: "TAB",
                    location: "ITINERARYDAY",
                    name: `${poiTitle}`,
                    position: "2",
                    text: item.label,
                  },
                });
              }}
            >
              {item.label}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}

Tabs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string.isRequired })
  ).isRequired,
  handleSelect: PropTypes.func.isRequired,
  activeIndex: PropTypes.number.isRequired,
  poiTitle: PropTypes.string.isRequired,
};
